import React from "react";
import { FaTimes, FaShare, FaExclamationTriangle, FaInfoCircle } from "react-icons/fa";

const PostAllConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  totalMedia = 0,
  context = "event",
}) => {
  if (!isOpen) return null;

  const hasMedia = totalMedia > 0;
  const scopeWord = context === "event-item" ? "event item" : "event";

  return (
    <div
      className="modal-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.75)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        padding: "20px",
      }}
      onClick={onClose}
    >
      <div
        className="modal-content modal-light"
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          maxWidth: "480px",
          width: "100%",
          padding: "24px",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div
              style={{
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                backgroundColor: hasMedia ? "#e6f0ff" : "#fff4e5",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: hasMedia ? "#1e63d8" : "#b76e00",
              }}
            >
              {hasMedia ? <FaInfoCircle size={24} /> : <FaExclamationTriangle size={24} />}
            </div>
            <h2
              style={{
                margin: 0,
                fontSize: "20px",
                fontWeight: 600,
                color: "#1a1a1a",
              }}
            >
              {hasMedia ? "Post all media?" : "Nothing to post"}
            </h2>
          </div>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#666",
              fontSize: "20px",
            }}
            aria-label="Close modal"
          >
            <FaTimes />
          </button>
        </div>

        <div style={{ marginBottom: "24px" }}>
          {hasMedia ? (
            <>
              <p
                style={{
                  margin: "0 0 12px 0",
                  fontSize: "16px",
                  lineHeight: 1.5,
                  color: "#333",
                }}
              >
                No media is selected, so{" "}
                <strong>
                  all {totalMedia} media {totalMedia === 1 ? "item" : "items"}
                </strong>{" "}
                from this {scopeWord} will be included in the post.
              </p>
              <p
                style={{
                  margin: 0,
                  fontSize: "14px",
                  lineHeight: 1.5,
                  color: "#666",
                }}
              >
                Want to post only some? Cancel and select the media you want first.
              </p>
            </>
          ) : (
            <p
              style={{
                margin: 0,
                fontSize: "16px",
                lineHeight: 1.5,
                color: "#333",
              }}
            >
              This {scopeWord} has no images or videos to post. Add media first, then try again.
            </p>
          )}
        </div>

        <div
          style={{
            display: "flex",
            gap: "12px",
            justifyContent: "flex-end",
          }}
        >
          {hasMedia ? (
            <>
              <button
                onClick={onClose}
                className="btn btn-outline"
                style={{
                  padding: "10px 20px",
                  fontSize: "14px",
                  fontWeight: 500,
                  borderRadius: "6px",
                  border: "1px solid #ddd",
                  backgroundColor: "#fff",
                  color: "#333",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  onConfirm();
                  onClose();
                }}
                className="btn btn-primary"
                style={{
                  padding: "10px 20px",
                  fontSize: "14px",
                  fontWeight: 500,
                  borderRadius: "6px",
                  border: "none",
                  backgroundColor: "#1e63d8",
                  color: "#fff",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <FaShare size={14} />
                Continue
              </button>
            </>
          ) : (
            <button
              onClick={onClose}
              className="btn btn-primary"
              style={{
                padding: "10px 20px",
                fontSize: "14px",
                fontWeight: 500,
                borderRadius: "6px",
                border: "none",
                backgroundColor: "#1e63d8",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              OK
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PostAllConfirmModal;
